import { useParams } from 'react-router-dom';
import { AccountManager, Util } from '@bluedolphin/util-module-mf';
import { useUser } from '../../providers/user';
import { useEffect } from 'react';

/**
 * Force Login page component
 *
 * @returns {JSX.Element}
 */
export default function ForceLogin(): JSX.Element {
    const { tenantId } = useParams<any>();
    const { search } = window.location;
    const { resetUser } = useUser();

    useEffect(() => {
        resetUser();
    }, []);

    AccountManager.removeItem('token');
    AccountManager.removeItem('exp');
    AccountManager.setItem('logout', true);

    Util.setGoTo(tenantId);

    window.history.pushState({}, '', `/${tenantId}/login${search}`);

    return null;
}
